import { serverHttp } from "@/plugins/axios";

export const captcha = function() {
    return serverHttp.get("/api/captcha").then(response => {
        return response.data.data;
    });
};

export const sendVerifyCode = function(phone, captchaCode, captchaSign, captchaExpires) {
    return serverHttp
        .post("/api/notices/verify-code", {
            phone: phone,
            captcha: captchaCode,
            captchaSign: captchaSign,
            captchaExpires: captchaExpires
        })
        .then(response => {
            return response.data.data;
        });
};

export const register = function(phone: string, verifyCode: string, password: string, passwordConfirm: string) {
    return serverHttp
        .post(`/api/register/users`, {
            phone: phone,
            verifyCode: verifyCode,
            password: password,
            passwordConfirm: passwordConfirm
        })
        .then(response => {
            return response.data.data;
        });
};

export const checkPhone = function(phone) {
    return serverHttp
        .get("/api/users/reset-password", {
            params: { phone: phone }
        })
        .then(response => {
            return response.data.data;
        });
};

export const resetPassword = function(phone: string, verifyCode: string, password: string, passwordConfirm: string) {
    return serverHttp
        .put(`/api/users/reset-password`, {
            phone: phone,
            verifyCode: verifyCode,
            password: password,
            passwordConfirm: passwordConfirm
        })
        .then(response => {
            return response.data.data;
        });
};
